import { Injectable } from '@angular/core';
import { BasePagedCrudService } from "../shared/crud/base-crud.service";
import { IdentityRoleDto } from "../role-data/models/RoleDtos";
import { HttpClient } from "@angular/common/http";
import { CrudSettings, QueryParams } from "../shared/crud/abstractions/base-crud";
import { IdentityUserUpdateRolesDto } from './models/UserRoleDtos';
import { ListResultDto } from '../shared/crud/models/ListResultDto';
import { EnvironmentService } from '../core/environment/environment.service';
import {DialogService} from "../shared/dialog/dialog.service";
import {MatSnackBar} from "@angular/material/snack-bar";

export class UserRoleCrudSettings implements CrudSettings<string, ListResultDto<IdentityRoleDto>> {
  baseUrl = '';
  postUrl = undefined;
  queryParam = undefined;
  createSuffix = undefined;
  deleteSuffix = undefined;
  deleteIdLocation: 'PATH' | 'QUERY' = 'PATH';
  editSuffix = undefined;
  editPostfix = 'roles';
  editIdLocation: 'PATH' | 'QUERY' = 'PATH';
  editMethod: 'PUT' | 'PATCH' = 'PUT';
  getListSuffix = 'roles';
  getSuffix = undefined;
  getPostfix = 'roles';
  getIdLocation: 'PATH' | 'QUERY' = 'PATH';
  idGetter = (entity: ListResultDto<IdentityRoleDto>) => '';

  mapper(id: string): QueryParams {
    const dict = new Map<string, string>();
    dict.set('id', id);
    return { params: dict }
  }

  constructor(private environmentService: EnvironmentService) {
    this.baseUrl = this.environmentService.getConfig().api.baseUrl + '/api/identity/users';
  }
}

@Injectable({
  providedIn: null
})
export class UserRoleDataService
  extends BasePagedCrudService<string, ListResultDto<IdentityRoleDto>, null, IdentityUserUpdateRolesDto>{

  constructor(private _http: HttpClient, private environmentService: EnvironmentService, override dialogService: DialogService) {
    super(_http, new UserRoleCrudSettings(environmentService),dialogService);
  }
}
